/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import React, { createRef } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Resizer from "react-image-file-resizer";

// @mui material components
import Icon from "@mui/material/Icon";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDButton from "components/MDButton";

function PurchasePaySlip({ uploadData }) {
  const { t } = useTranslation();
  const fileInput = createRef();

  const resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        1024,
        1024,
        "JPEG",
        100,
        0,
        (uri) => {
          resolve(uri);
        },
        "base64"
      );
    });

  const handleImageChange = async (e) => {
    try {
      const file = e.target.files[0];
      const image = await resizeFile(file);

      uploadData(image, file);
      fileInput.current.value = null;
    } catch (err) {
      console.log(err);
    }
  };

  const handleClick = () => {
    fileInput.current.click();
  };

  return (
    <div>
      <Grid container>
        <Grid item xs={12}>
          <input
            ref={fileInput}
            accept=".png, .jpg"
            style={{ display: "none" }}
            type="file"
            onChange={handleImageChange}
          />
          <label htmlFor="file-open">
            <MDButton
              variant="gradient"
              color="info"
              size="small"
              component="span"
              onClick={() => handleClick()}
            >
              <Icon>image</Icon>&nbsp;{t("upload.browse")}
            </MDButton>
          </label>
        </Grid>
      </Grid>
    </div>
  );
}

PurchasePaySlip.propTypes = {
  uploadData: PropTypes.func.isRequired,
};

export default PurchasePaySlip;
